const axios = require("axios");
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

document.querySelectorAll(".ajax-form").forEach(item => {
  item.addEventListener("submit", event => {
    event.preventDefault();
    let target = event.target;
    target.classList.add("sending");
    axios.post(target.action, new FormData(event.target)).then(() => {
      const dataLayer = window.dataLayer || [];

      dataLayer.push({
        event: "form_submission",
        formType: target.id === "newsletter" ? "newsletter" : "contact_form"
      });

      target.reset();
      document.activeElement.blur();
      const elems = document.querySelectorAll(".is-floating");

      [].forEach.call(elems, function(el) {
        el.classList.remove("is-floating");
      });

      setTimeout(() => {
        target.classList.add("success");
        setTimeout(() => {
          target.classList.remove("success");
          target.classList.remove("sending");
        }, 1000);
      }, 300);
    });

    [...item.elements].forEach(input => {
      input.addEventListener("focus", () => {
        target.classList.remove("success");
      });
    });
  });
});

const heightLimit = 200; /* Maximum height: 200px */

document.querySelectorAll(".textarea-auto").forEach(item => {
  item.addEventListener("input blur", event => {
    event.target.style.height =
      Math.min(event.target.scrollHeight, heightLimit) + "px";
  });
});
